<template>
  <div id="Student-edit">

    <IForm ref="formInline" :model="edit" :elem="studentElem" :rules="studentRule"
           :label-width="100" @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col :span="12"><FormItem label="姓名" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入学生姓名" maxlength="50"/></FormItem></Col>
          <Col :span="12">
            <FormItem label="性别" prop="gender">
              <Select v-model="edit.gender" style="width: 100%;">
                <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="证件类型" prop="idCardType">
              <Select v-model="edit.idCardType" @on-change="changeIdCardType" style="width: 100%;">
                <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="证件号码" prop="idCard" :required="edit.idCardType!==2">
              <Input v-model="edit.idCard" type="text" placeholder="请输入证件号码" maxlength="20" @on-change="cardchange" :disabled="edit.idCardType === 2"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="出生日期" prop="birthday" :required="true">
              <DatePicker :value="edit.birthday" :editable="false" @on-change="changeBirthday"
                          type="date" format="yyyy-MM-dd" placeholder="出生日期" style="width:100%;"/>
            </FormItem>
          </Col>
          <Col :span="12"><FormItem label="手机号码" prop="phone"><Input v-model="edit.phone" type="number" placeholder="请输入手机号码" maxlength="11"/></FormItem></Col>
        </Row>
        <Row>
          <Col :span="12"><FormItem label="固定电话" prop="phone"><Input v-model="edit.telPhone" type="tel" placeholder="请输入固定电话"/></FormItem></Col>
          <Col :span="12">
            <FormItem  label="学校名称"  prop="schoolId">
              <el-select v-model.trim="edit.schoolId" placeholder="学校名称" clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width:100%;">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem  label="年级" prop="gradeId">
              <el-select v-model.trim="edit.gradeId" placeholder="年级" clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width:100%;">
                <el-option v-for="item in gradesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem  label="班级"  prop="classesId">
              <el-select v-model.trim="edit.classesId" placeholder="班级" clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" style="width:100%;">
                <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="民族" prop="nationsId">
              <Select v-model="edit.nationsId" style="width:100%;">
                <Option v-for="item in nationsList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="状态" prop="status">
              <Select v-model="edit.status" style="width:100%;">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="现住址" prop="currentAddress">
              <Input v-model="edit.currentAddress" type="text" placeholder="请输入现住址" maxlength="255"/>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="户籍地" prop="address">
              <Input v-model="edit.address" type="text" placeholder="请输入户籍地" maxlength="255"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="来市时间" prop="arrivalDate">
              <DatePicker :value="edit.arrivalDate" :editable="false" @on-change="changeArrivalDate"
                          type="month" format="yyyy-MM" placeholder="来市时间" style="width:100%;"/>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="居住类型" prop="resideCondition">
              <Select v-model="edit.resideCondition" style="width:100%;">
                <Option v-for="item in enums.resideConditionList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="入户情况" prop="occupancyType">
              <Select v-model="edit.occupancyType" style="width:100%;">
                <Option v-for="item in enums.occupancyTypeList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="入户时间" prop="occupancyDate">
              <DatePicker :value="edit.occupancyDate" :editable="false" @on-change="changeOccupancyDate"
                          type="month" format="yyyy-MM" placeholder="入户时间" style="width:100%;"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="入学时间" prop="entryDate">
              <DatePicker :value="edit.entryDate" :editable="false" @on-change="changeEntryDate"
                          type="date" format="yyyy-MM-dd" placeholder="入学时间" style="width:100%;"/>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="居住类型" prop="resideType">
              <Select v-model="edit.resideType" style="width:100%;">
                <Option v-for="item in enums.resideTypeList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="12">
            <FormItem label="学历层次" prop="educationalLevel">
              <Select v-model="edit.educationalLevel" style="width:100%;">
                <Option v-for="item in enums.educationalLevelList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="首次入托日期" prop="nurseryDate">
              <DatePicker :value="edit.nurseryDate" :editable="false" @on-change="changeNurseryDate"
                          type="date" format="yyyy-MM-dd" placeholder="首次入托日期" style="width:100%;"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="既往病史" prop="pastMedicalHistorys">
              <MyCheckBox :enumList="enums.pastMedicalHistoryList" :ignore-list="['1']" :dataList.sync="pastMedicalHistorys" :dataStr.sync="edit.pastMedicalHistory">
                <Input v-model="edit.pastMedicalHistoryOther" v-if="edit.pastMedicalHistory.indexOf('7') !== -1" placeholder="请输入" maxlength="255"/>
              </MyCheckBox>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="过敏史" prop="allergyHistory">
              <RadioGroup v-model="edit.allergyHistory">
                <Radio v-for="item in enums.allergyHistoryList" v-bind:key="item.code" :label="item.code" @dblclick.native.prevent="()=>{form.other = null}">{{item.value}}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="12">
            <Input v-model="edit.allergyHistoryOther" v-if="edit.allergyHistory === 2" placeholder="请输入" maxlength="255"/>
          </Col>
        </Row>
        <Row>
          <Col span="8" style="text-align: left;">
            <FormItem label="传染病接触史" prop="infectionHistory">
              <RadioGroup v-model="edit.infectionHistory">
                <Radio v-for="item in enums.infectionHistoryList" v-bind:key="item.code"  :label="item.code" @dblclick.native.prevent="()=>{form.other = null}">{{item.value}}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="12" style="text-align: left;">
            <Input v-model="edit.infectionHistoryOther" v-if="edit.infectionHistory === 2" placeholder="请输入" maxlength="255"/>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <button type="button" class="ivu-btn ivu-btn-primary" @click="addFamilyMembers(1)"><i class="el-icon-plus"/>新增亲属</button>
          </Col>
        </Row>

        <Row v-if=" familyMembers && familyMembers.length > 0">
          <Col span="23">
            <vxe-table border class="mytable-scrollbar" ref="familyMember"
                      :row-config="{isCurrent: true, isHover: true}" :custom-config="{storage: true,visible:true}" :data="familyMembers"
                      :sort-config="{trigger: 'cell'}" style="margin-top: 10px;">
              <vxe-column  v-for="item in columns" :field="item.key" :title="item.title" :visible="item.visible"
                           :formatter="item.formatter?item.formatter:''" :fixed="item.fixed ? item.fixed : ''" :width="item.width">
                <template #default="{ row }">
                  <Select v-model="row[item.key]" v-if="item.key == 'type'" placement="top" style="z-index: 9999;" transfer>
                    <Option v-for="item in enums.familyMemberTypeList" :value="item.code" v-bind:key="item.code"
                            style="z-index: 9999;">{{ item.value }}</Option>
                  </Select>
                  <Select v-model="row[item.key]" v-else-if="item.key.indexOf('idcardType') !== -1" placement="top" transfer>
                    <Option v-for="item in enums.idCardTypes" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                  </Select>
                  <el-input v-model="row[item.key]" placeholder="请输入身份证" maxlength="18" size="mini" v-else-if="item.key == 'idcard'"  @input="idcardInput(row)" />
                  <Select v-model="row[item.key]" v-else-if="item.key.indexOf('gender') !== -1" placement="top" transfer>
                    <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
                  </Select>
                  <Select v-model="row[item.key]" v-else-if="item.key.indexOf('occupationId') !== -1" placement="top" transfer>
                    <Option v-for="item in enums.occupationsList" :value="item.code" v-bind:key="item.code"  >{{ item.value }}</Option>
                  </Select>
                  <DatePicker :value="row[item.key]" :editable="false" v-else-if="item.key.indexOf('birthday') !== -1"
                              @on-change="(val)=>{row.birthday=val}"
                              type="date" format="yyyy-MM-dd" placeholder="出生日期" placement="top" transfer/>
                  <el-input v-model="row[item.key]" placeholder="请输入" maxlength="125" size="mini" v-else/>
                </template>
              </vxe-column>

              <vxe-column title="操作" width="180" show-overflow fixed="right">
                <template #default="{ row }">
                  <el-button size="small" type="text" @click="addFamilyMembers(-1,row.rowId)">删除</el-button>
                  <span v-if="row.status == 2">默认家属</span>
                  <el-button size="small" type="text" @click="setDefault(row.rowId)"  v-if="row.status == 1">设为默认家属</el-button>
                </template>
              </vxe-column>
            </vxe-table>
          </Col>
        </Row>
      </div>

    </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/students/students";
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "StudentsEdit",
  mixins: [mixins],
  data() {
    return {
      enums:Object.assign({},enums),
      edit : {
        schoolId: "",
        gradeId: "",
        classesId: "",
        name: "",
        gender: "",
        idCardType: "",
        idCard: "",
        birthday: "",
        phone: "",
        telPhone: "",
        nationsId: 1,
        currentAddress: "",
        address: "",
        entryDate: "",
        arrivalDate: "",
        resideType: "",
        resideCondition: "",
        occupancyType: "",
        occupancyDate: "",
        educationalLevel: "",
        familySituation: "",
        nurseryDate: "",
        pastMedicalHistory: "1",
        pastMedicalHistoryOther: "",
        allergyHistory: 1,
        allergyHistoryOther: "",
        infectionHistory: 1,
        infectionHistoryOther: "",
        status:1,
        familyMembers:[]
      },
      init:"",
      columns : [
        {
          title: "姓名",
          key: "name",
          visible: true,
          width:120
        },
        {
          title: "亲属关系",
          key: "type",
          visible: true,
          width:120
        },
        {
          title: "证件类型",
          key: "idcardType",
          visible: true,
          width:200
        },
        {
          title: "证件号码",
          key: "idcard",
          visible: true,
          width:200
        },
        {
          title: "性别",
          key: "gender",
          visible: true,
          width:80
        },
        {
          title: "出生日期",
          key: "birthday",
          visible: true,
          width:200
        },
        {
          title: "职业",
          key: "occupationId",
          visible: true,
          width:200
        },
        {
          title: "手机号码",
          key: "phone",
          visible: true,
          width:200
        },
        {
          title: "固定电话",
          key: "telPhone",
          visible: true,
          width:200
        },
      ],
      pastMedicalHistorys:[],
      gradesList:[],
      classList:[],
      loading: {
        form: false,
        btn: false
      },
      studentElem:[],
      studentRule: {
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {maxlength:50,message:"姓名长度不能超过50个字",trigger: 'blur'}
        ],
        gender: [
          {required: true, message: "请选择性别", type:'number'}
        ],
        idCardType: [
          {required: true, message: "请选择证件类型", type:'number'}
        ],
        idCard: [
          {validator:function(rule, value, callback){
              if ((!this.edit.idCardType || this.edit.idCardType !== 2) && (!value || value.length === 0)) {
                callback(new Error('证件号码不能为空'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        birthday: [
          {validator:function(rule, value, callback){
              if (!this.edit.birthday || this.edit.birthday.length === 0) {
                callback(new Error('请选择出生日期'));
              } else if (!this.isValidDateBasic(this.edit.birthday)) {
                callback(new Error('请输入正确的出生日期'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        schoolId: [
          {required: true, message: "请选择学校"}
        ],
        gradeId: [
          {required: true, message: "请选择年级", type:'number'}
        ],
        classesId: [
          {required: true, message: "请选择班级", type:'number'}
        ],
      },
    };
  },
  watch:{
    /*'edit.idCard': {
      handler(newVal){
        if(newVal && newVal.length === 18){
          this.edit.birthday = newVal.substring(6, 10) + "-" + newVal.substring(10, 12) + "-" + newVal.substring(12, 14);
          let sex = newVal.substring(16, 17);
          this.edit.gender = parseInt(sex) % 2 === 0 ? 2 : 1;
        }
      }
    },*/
  },
  computed:{
    familyMembers(){
      if (this.edit.familyMembers){
        let tempList = Object.assign([],this.edit.familyMembers)
        tempList.forEach(it=>{ it.rowId = Math.random()})
        this.edit.familyMembers = tempList;
        return this.edit.familyMembers;
      }else{
        this.edit.familyMembers=[];
        return this.edit.familyMembers;
      }
    }
  },
  mounted() {
    this.init = this.edit=Object.assign({}, this.edit)
    this.applyNationsList();
  },
  methods: {
    isValidDateBasic(dateString) {
      const date = new Date(dateString);
      // 检查 date 是否是 Date 的实例，并且其时间戳不是 NaN
      return date instanceof Date && !isNaN(date.getTime());
    },
    idcardInput(row){
      if(row.idcard && row.idcard.length == 18) {
        let yearBirth = row.idcard.substring(6, 10);
        let monthBirth = row.idcard.substring(10, 12);
        let dayBirth = row.idcard.substring(12, 14);
        let _birthday = yearBirth + "-" + monthBirth + "-" + dayBirth;
        let _gender = (row.idcard.substring(16, 17) % 2 == 0) ? 2 : 1;

        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index];
          let birthday = temp.birthday;
          let gender = temp.gender;
          if (temp.rowId === row.rowId){
            birthday = _birthday;
            gender = _gender;
          }
          this.$set(this.edit.familyMembers, index,
              {
                id: temp.id,
                rowId: temp.rowId,
                name: temp.name,
                type: temp.type,
                idcardType: temp.idcardType,
                idcard: temp.idcard,
                gender: gender,
                birthday: birthday,
                phone: temp.phone,
                telPhone: temp.telPhone,
                occupationId: temp.occupationId,
                status: temp.status
              }
          )
        }
      }
    },
    addFamilyMembers(type, id){
      if (type > 0){
        let status = this.edit.familyMembers.length == 0 ? 2 : 1;
        this.edit.familyMembers.push({ rowId: Math.random(), name:"",type:"",idcardType:"",idcard:"",gender:"",birthday:"",phone:"",telPhone:"",occupationId:"",status: status});
      }else{
        for (let index = 0; index < this.edit.familyMembers.length; index++) {
          let temp = this.edit.familyMembers[index]
          if (temp.rowId === id){
            this.edit.familyMembers.splice(index,1);
          }
        }
      }
    },
    setDefault(id) {
      for (let index = 0; index < this.edit.familyMembers.length; index++) {
        let temp = this.edit.familyMembers[index]
        let status = 1;
        if (temp.rowId === id) {
          status = 2;
        }
        this.$set(this.edit.familyMembers, index,
            {
              id: temp.id,
              rowId: temp.rowId,
              name: temp.name,
              type: temp.type,
              idcardType: temp.idcardType,
              idcard: temp.idcard,
              gender: temp.gender,
              birthday: temp.birthday,
              phone: temp.phone,
              telPhone: temp.telPhone,
              occupationId: temp.occupationId,
              status: status
            }
        )
      }
    },
    changeIdCardType(val){
      if(val && val == 1) {
        this.cardchange();
      }else if(val && val === 2){
        this.edit.idCard = "";
      }
    },
    cardchange(){
      if((this.edit.idCardType && this.edit.idCardType == 1 && this.edit.idCard && this.edit.idCard.length == 18)
        || (this.edit.idCard && this.edit.idCard.length == 18 && this.edit.idCard.startsWith("[0-9]+"))){
        this.edit.birthday = this.edit.idCard.substring(6, 10) + "-" + this.edit.idCard.substring(10, 12) + "-" + this.edit.idCard.substring(12, 14);
        let sex = this.edit.idCard.substring(16, 17);
        this.edit.gender = parseInt(sex) % 2 == 0 ? 2 : 1;
      }
    },
    handleShoolChange(item) {
      this.edit.schoolId = item.value.toString();
      this.changeSchool(this.edit.schoolId, null, null);
    },
    handleGradeChange(item) {
      this.edit.gradeId = item.id;
      this.changeGrade(this.edit.schoolId, this.edit.gradeId, null);
    },
    handleClassChange(item){
      this.edit.classesId = item.id;
    },
    changeSchool(schoolId, gradeId, classesId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.edit.schoolId = schoolId;
        this.edit.gradeId = "";
        this.gradesList =[]
        if (res.errcode === 1 && res.data){
          this.gradesList = res.data;
        }

        if(gradeId){
          this.changeGrade(schoolId, gradeId, classesId);
        }
      })
    },
    changeGrade(schoolId, gradeId, classesId){
      if(!gradeId){
        return;
      }

      _classesList({schoolId:schoolId, gradeId : gradeId}).then(res=>{
        this.edit.gradeId = gradeId;
        this.edit.classesId = "";
        this.classList =[]
        if (res.errcode === 1 && res.data){
          this.classList = res.data;
          this.edit.classesId = (classesId ? classesId : "");
        }
      })
    },
    changeArrivalDate(val){
      this.edit.arrivalDate= val;
    },
    changeOccupancyDate(val){
      this.edit.occupancyDate= val;
    },
    changeEntryDate(val){
      this.edit.entryDate= val;
    },
    changeNurseryDate(val){
      this.edit.nurseryDate= val;
    },
    changeBirthday(val){
      this.edit.birthday= val;
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();

      this.edit = Object.assign({}, this.init)
      this.gradesList = [];
      this.classList = [];
      this.applySchoolsList();

      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {

    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
          if (res.errcode === 1) {
            const edit = Object.assign({}, res.data);
            edit.schoolId = edit.schoolId.toString();
            this.changeSchool(edit.schoolId, edit.gradeId, edit.classesId);
            delete edit.gradeId;
            if(edit.pastMedicalHistory){
              this.pastMedicalHistorys = edit.pastMedicalHistory.split(",");
            }
            this.edit = {
              ...edit,
            };
            this.$forceUpdate();
          }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _save(this.edit).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
